const BaseComponent = require('common/newsCarousel');
class newsCarousel2 extends BaseComponent{
}
module.exports = newsCarousel2;